import SchoolLookUp from './SchoolLookUp'
export default SchoolLookUp
